const contentTitles = {
    drug: {
        administration: 'Administration',
        bbw: 'BBW',
        contraindications: 'Contraindications',
        doseModifications: 'Dose Modifications',
        howSupplied: 'How Supplied',
        indications: 'Indication(s)',
        interactions: 'Drug Interactions',
        labAndMonitoring: 'Lab and Monitoring Guidelines',
        miscCounsellingPoints: 'Patient Counselling Points',
        overview: 'Drug Overview',
        recommendedDose: 'Recommended Dose',
        rems: 'REMS',
        sideEffects: 'Side Effects',
        storage: 'Storage',
        warningsAndPrecautions: 'Warning and Precautions',
        geneTesting: 'Gene Testing',
        reproductionPregnancyLactation: 'Reproduction, Pregnancy, Lactation',
        references: 'References',
    },
    disease: {
        complications: 'Complications/Progression',
        goals: 'Goals of Therapy',
        management: 'Therapy Management',
        misc: 'Miscellaneous',
        overview: 'Disease Overview',
        prevention: 'Prevention',
        references: 'References & Version History',
        support: 'Support',
        treatment: 'Treatment',
    },
    teaching: {
        generic: 'Generic',
        evaluation: 'Evaluation',
        strategy: 'Strategies',
        references: 'References',
    },
};

const scrollContainerId = 'content-library-edit-scroll-container';

export { contentTitles, scrollContainerId };
